<template>

    <div class="col-span-6">

        <div class="col-span-6">

            <div class="flex flex-row py-4 px-4 justify-start w-full max-w-xl mx-auto">

                <div class="mr-3 flex self-center">

                    <div class="flex logoUpload relative">
                        <label for="upload-logo" class="upload-button z-1"
                            :class="{ 'empty': $page.props.user.current_team.team_logo_url == '' }" id="upload-button"
                            title="Select an image for your Logo"
                            :style="'background-image:url(' + $page.props.user.current_team.team_logo_url + ')'">
                            <div>Upload</div>
                        </label>
                        <input class="absolute opacity-0 z-0 w-0 h-0" type="file" name="logo" id="upload-logo"
                            ref="photo" @change="upload_logo()" />
                        <div v-if="is_uploading"
                            class="absolute w-full h-full flex flex-col justify-center items-center bg-gray-700 rounded-md">
                            <spinner class="h-8 w-8 text-white"></spinner>
                        </div>
                    </div>
                </div>



                <div id="heading_msg" class="flex self-center align-center"
                    :class="{ 'empty': $page.props.user.current_team.team_logo_url == '' }">
                    <div class="is_empty flex items-center"
                        :class="{ 'hidden': $page.props.user.current_team.team_logo_url != '' }">
                        <vue-feather type="arrow-left" class="h-6 w-6 mr-1 align-center"></vue-feather> Set your logo!
                    </div>
                    <div class="is_ok " :class="{ 'hidden': $page.props.user.current_team.team_logo_url == '' }">
                        <!-- <strong>{{ $page.props.user.current_team.name }}</strong> -->
                        <input type="text" ref="team_name_field" v-model="form.name" @input="changedTeamName"
                            :size="team_field_size"
                            class="text-center inline py-0 mt-0 px-0.5 border-0 border-b-2 border-gray-200 focus:ring-0 focus:border-blue-500 font-bold focus:bg-blue-50" />

                        <span>&nbsp;is requesting a video recording of your screen.</span>
                    </div>
                </div>
            </div>


            <div class="logoUpload flex w-full max-w-xl mx-auto" v-if="is_uploading && false">
                <div class="upload-info my-1 ml-4 flex flex-row flex-grow">
                    <span>Sending image…</span>
                </div>
            </div>


            <div class="videobox stain light flex flex-col w-full rounded-lg max-w-xl mx-auto shadow-md"
                :style="'background-color:' + widget_settings.color + ';'">

                <div class="content flex flex-grow flex-col justify-center align-center flex-grow mt-10"
                    :class="{ 'text-black': is_light, 'text-white': !is_light }">
                    <div class="message my-5 text-center flex flex-col">
                        <div class="icons mb-3 flex flex-row justify-center">
                            <div class="img monitor mr-3  self-center">
                                <vue-feather type="monitor" class="h-7 w-7"></vue-feather>
                            </div>
                            <div class="img mic self-center">
                                <vue-feather type="mic" class="h-6 w-6"></vue-feather>
                            </div>
                        </div>
                        <p class="text-lg">Screen recording &amp; audio</p>
                    </div>
                    <div class="actions mt-10 mb-20 flex justify-center">
                        <div href="#"
                            class="big-button flex flex-col self-center justify-center rounded-2xl  w-20 h-20 transform duration-150 ease-in-out hover:scale-100 shadow-lg"
                            :class="{ 'bg-black': is_light, 'bg-white': !is_light }">
                            <div class="icon flex justify-center flex-grow">
                                <div class="align-self-center mt-5">
                                    <div class="rounded-full bg-red-500 h-5 w-5"></div>
                                </div>
                            </div>
                            <div class="label flex justify-center mb-2 text-sm font-semibold uppercase"
                                :class="{ 'text-black': !is_light, 'text-white': is_light }">
                                Record
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex w-full h-8 justify-center align-center bg-opacity-30 text-xs items-center rounded-b-lg"
                    :class="{ 'opacity-0': hide_zest_footer, 'text-black bg-black ': is_light, 'text-white bg-white ': !is_light }">
                    <img class="mr-1" src="/img/lightning.svg" alt="zap" width="15" />
                    by {{ app_name }}
                </div>

            </div>






        </div>


        <div class="col-span-6 text-center mt-4">

            <div class="flex flex-row justify-center">

                <a href="#" @click.prevent.stop="changeColor(color)" v-for="(color, index) in preset"
                    :key="'color_' + index"
                    class="border-4 bg-white border-transparent rounded-full w-16 h-16 flex flex-col justify-center cursor-pointer"
                    :style="color == widget_settings.color ? 'border-color:' + color : ''">
                    <div class="rounded-full w-12 h-12 border-2 border-transparent flex flex-col justify-center self-center transform duration-200 hover:scale-90"
                        :class="{ 'hover:border-gray-700': color != widget_settings.color }"
                        :style="'background-color:' + color">
                        <vue-feather v-if="color == widget_settings.color" type="check" class="flex self-center"
                            :class="{ 'text-white': color == '#4B4CDC' }"></vue-feather>
                    </div>
                </a>
                <div class="border-4 bg-white border-transparent rounded-full w-16 h-16 mr-2 flex flex-col justify-center cursor-pointer"
                    :style="active_custom ? 'border-color:' + widget_settings.color : ''">
                    <div class="rounded-full w-12 h-12 border-2 border-dashed border-transparent flex flex-col justify-center self-center relative overflow-hidden bg-gray-100 transform duration-200 hover:scale-90"
                        :class="{ 'border-gray-400 hover:border-gray-700 hover:border-solid': !active_custom }"
                        :style="active_custom ? 'background-color:' + widget_settings.color : ''">
                        <vue-feather v-if="active_custom" type="hash" class="flex self-center z-10"
                            :class="{ 'text-white': !is_light, 'text-black': is_light }"></vue-feather>
                        <vue-feather v-else type="hash"
                            class="flex self-center z-10 w-5 h-5 text-gray-400"></vue-feather>
                        <input class="absolute opacity-0 z-20 block cursor-pointer w-12 h-12"
                            v-tippy="{ content: 'Pick your own color' }" type="color" :value="widget_settings.color"
                            @change="changeCustom($event)" />
                    </div>


                </div>
            </div>

        </div>

        <div class="col-span-6 mt-8" v-if="is_modal">
            <div class="flex flex-row justify-center px-4">
                <jet-secondary-button @click="$inertia.visit(route('settings.index'))">
                    Settings page for more details
                    <vue-feather type="arrow-right" class="w-4 h-4 ml-2" />
                </jet-secondary-button>
            </div>
        </div>

        <div class="col-span-6" v-else>


            <jet-section-border />

            <div class="flex flex-row justify-center px-4 text-gray-600">
                <span class="flex-grow" :class="{ 'text-gray-400': !canToggleFooter }">Remove {{ app_name }}
                    branding<br />
                    <span v-if="!canToggleFooter" class="text-sm text-gray-400">Only available
                        <inertia-link v-if="$page.props.canManagePlan" :href="route('subscription.index')"
                            class="text-blue-500 hover:underline">on paid plans</inertia-link>
                        <span v-else class="text-gray-600">on paid plans</span>
                    </span>
                </span>
                <toggle :checked="hide_zest_footer" @click.prevent.stop @update="toggleHideFooter"></toggle>
            </div>

            <jet-section-border />

            <div class="flex flex-row justify-center px-4 text-gray-600">
                <span class="flex-grow">
                    Customers can add text before submitting a recording
                </span>
                <toggle :checked="customer_can_add_comment" @click.prevent.stop @update="toggleAddComment"></toggle>
            </div>

            <jet-section-border />

            <div class="flex flex-col justify-center px-4">

                <list-toggle>
                    <template #title>
                        Requirements for your Logo
                    </template>
                    <template #content>
                        <div class="rounded-xl p-5 bg-gray-100">
                            <p class="">Select an image of your Company’s logo from your computer.</p>
                            <p class="pt-2">The file type must be any image of these formats:<br /><strong>JPG, SVG,
                                    PNG, GIF.</strong></p>
                            <p class="pt-2">The file size must not exceed <strong>4 MB.</strong></p>
                            <p class="pt-2"><strong>Tip to get the best fit:</strong> choose a square image, with a
                                minimum dimension of 300px or more for non-svg files.</p>
                        </div>
                    </template>
                </list-toggle>

            </div>
        </div>


    </div>



</template>






<script>

import Spinner from '@/Components/UI/Spinner'
import ColorUtil from "@/tools.js"
import ListToggle from '@/Components/UI/ListToggle'
import JetSectionBorder from '@/Jetstream/SectionBorder'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import Toggle from '@/Components/UI/Toggle'
// const CancelToken = axios.CancelToken;
// let cancel;

export default {

    props: ['w_settings'],

    components: {
        Spinner, ListToggle, JetSectionBorder, JetSecondaryButton, Toggle,
    },

    data() {
        return {
            is_modal: false,
            preset: {
                indigo: "#4B4CDC",
                blue: "#2dd4ff",
                yellow: "#feda40",
                red: "#ff5967",
                grey: "#D1D5DB"
            },
            widget_settings: this.w_settings,
            is_uploading: false,
            form: this.$inertia.form({
                _method: 'PUT',
                name: this.$page.props.user.current_team.name,
                photo: null,
            }),
            onboard_customize: false,
            timeout: Object,
            buffer: 600,
            lastTypeMoment: 0,
            saving: false,
            canToggleFooter: this.$page.props.isz || this.$page.props.subscribed,
            app_name: this.$page.props.app_name,
        }
    },

    created() {
        if (this.$page.props.user.current_team.metadata) {
            let json = JSON.parse(this.$page.props.user.current_team.metadata)
            if (json.onboard_customize) {
                this.onboard_customize = json.onboard_customize == "yes"
            }
        }
    },
    computed: {
        team_field_size() {
            if (this.form.name.length >= 12) {
                return Math.round(this.form.name.length * 0.9) - 2
            }
            return Math.round(this.form.name.length * 0.9) - 1
        },
        active_custom() {
            //var ok = true;
            for (const color in this.preset) {
                if (this.widget_settings.color == this.preset[color]) {
                    return false
                }
            }
            return true
        },
        is_light() {
            return ColorUtil.lightOrDark(this.widget_settings.color) == "light"
        },
        hide_zest_footer() {
            if (this.widget_settings.hide_zest_footer) {
                return this.widget_settings.hide_zest_footer == 'yes'
            }
            return false
        },
        customer_can_add_comment() {
            if (this.widget_settings.customer_can_add_comment) {
                return this.widget_settings.customer_can_add_comment == 'yes'
            }
            return false
        }
    },
    mounted() {
    },
    methods: {
        changedTeamName() {
            if (this.form.name.length > 2) {
                let now = new Date().getTime();
                if (now - this.lastTypeMoment < this.buffer) {
                    clearTimeout(this.timeout);
                }
                if (this.saving) {
                    // this.cancel();
                }
                this.timeout = setTimeout(function () { this.saveTeamName() }.bind(this), this.buffer);
                this.lastTypeMoment = now;
            } else {
                clearTimeout(this.timeout);
            }
        },
        // cancel() {
        //     cancel();
        // },
        saveTeamName() {
            this.saving = true
            this.form.post(route('teams.update', this.$page.props.user.current_team), {
                errorBag: 'updateTeamName',
                preserveScroll: true,
                onSuccess: () => {
                    this.name_success()
                    this.saving = false
                }
            });
        },
        changeCustom: function (event) {
            this.changeColor(event.target.value)
        },
        changeColor: function (color) {
            //console.log('changeColor',color)
            this.update_color(color)
        },
        name_success: function () {
            let options = {
                type: "default",
                timeout: 6000,
                position: "top-right",
                hideProgressBar: false,
            }
            this.$moshaToast("Team name updated!", options)
        },
        upload_success: function () {
            let options = {
                type: "default",
                timeout: 6000,
                position: "top-right",
                hideProgressBar: false,
            }
            this.$moshaToast("Your logo was updated!", options)
        },
        upload_error_type: function () {
            let options = {
                type: "danger",
                timeout: -1,
                position: "top-right",
            }
            this.$moshaToast("Your file must match any of these formats: png, jpg, gif, svg", options)
        },
        upload_error_size: function () {
            let options = {
                type: "danger",
                timeout: -1,
                position: "top-right",
            }
            this.$moshaToast("The file size is limited to 4 MB", options)
        },
        upload_error_none: function () {
            let options = {
                type: "danger",
                timeout: -1,
                position: "top-right",
            }
            this.$moshaToast("Error: no file selected…", options)
        },
        upload_error_misc: function () {
            let options = {
                type: "danger",
                timeout: -1,
                position: "top-right",
            }
            this.$moshaToast("Unknown error occurred, try to change your logo from your Team Settings page.", options)
        },
        update_color: function (hexVal) {
            let url = this.$page.props.api_url + '/v1/settings/appearance';
            var params = {
                w_col: hexVal,
            };
            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    if (response.data) {
                        this.widget_settings = JSON.parse(response.data.settings)
                        let options = {
                            type: "default",
                            timeout: 2500,
                            position: "top-right",
                            hideProgressBar: false,
                        }
                        this.$moshaToast("Color updated!", options)
                        this.set_onboarding_done()
                    }
                })
                .catch(e => {
                    console.error(e);
                });
        },
        upload_logo: function () {
            if (this.is_uploading) {
                return
            }

            // a-t-on un fichier ?
            if (this.$refs.photo) {
                this.form.photo = this.$refs.photo.files[0]
            } else {
                this.upload_error_none()
                return
            }

            // est-il de la bonne taille ?
            let max_filesize = 4; // 4 Mo
            if (this.form.photo.size > 1024 * 1024 * max_filesize) {
                this.upload_error_size()
                return;
            }

            // a-t-il la bonne extension ?
            let ext = this.form.photo.name.substr(this.form.photo.name.lastIndexOf('.') + 1).toLowerCase();
            var allow = ['png', 'jpeg', 'jpg', 'gif', 'svg'];
            if (allow.indexOf(ext) < 0) {
                this.upload_error_type();
                return;
            }

            this.is_uploading = true

            this.form.post(route('teams.update', this.$page.props.user.current_team), {
                errorBag: 'updateTeamName',
                preserveScroll: true,
                onSuccess: () => {
                    this.clearPhotoFileInput()
                    this.upload_success()
                    this.is_uploading = false
                    this.set_onboarding_done()
                }
            });
        },
        clearPhotoFileInput() {
            if (this.$refs.photo?.value) {
                this.$refs.photo.value = null;
            }
        },
        set_onboarding_done() {
            if (this.onboard_customize) {
                //this.EventBus.emit('onboarding_step_validation','onboard_customize');
                return
            }
            let url = this.$page.props.api_url + '/v1/team/set_meta';
            var params = {
                meta: "onboard_customize",
                value: "yes"
            };
            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    if (response.data) {
                        this.onboard_customize = true
                        this.EventBus.emit('onboarding_step_validation', 'onboard_customize');
                    }
                })
                .catch(e => {
                    console.error(e);
                });
        },

        toggleAddComment() {
            let url = this.$page.props.api_url + '/v1/settings/appearance';
            var params = {
                customer_can_add_comment: this.customer_can_add_comment ? "no" : "yes",
            };
            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    if (response.data) {
                        this.widget_settings = JSON.parse(response.data.settings)
                        let options = {
                            type: "default",
                            timeout: 2500,
                            position: "top-right",
                            hideProgressBar: false,
                        }
                        this.$moshaToast("Setting updated!", options)
                    }
                })
                .catch(e => {
                    console.error(e);
                });

            if (this.customer_can_add_comment) {
                this.widget_settings.customer_can_add_comment = "no"
            } else {
                this.widget_settings.customer_can_add_comment = "yes"
            }
        },

        toggleHideFooter() {
            if (!this.canToggleFooter) {
                return
            }

            let url = this.$page.props.api_url + '/v1/settings/appearance';

            // if (this.hide_zest_footer) {
            //     this.widget_settings.hide_zest_footer = "no"
            // } else {
            //     this.widget_settings.hide_zest_footer = "yes"
            // }
            var params = {
                hide_zest_footer: this.hide_zest_footer ? "no" : "yes",
            };
            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    if (response.data) {
                        this.widget_settings = JSON.parse(response.data.settings)
                        let options = {
                            type: "default",
                            timeout: 2500,
                            position: "top-right",
                            hideProgressBar: false,
                        }
                        this.$moshaToast("Setting updated!", options)
                    }
                })
                .catch(e => {
                    console.error(e);
                });

            if (this.hide_zest_footer) {
                this.widget_settings.hide_zest_footer = "no"
            } else {
                this.widget_settings.hide_zest_footer = "yes"
            }
        },

    }

}

</script>

<style scoped>
label.upload-button {
    cursor: pointer;
    display: inline-block;
    font-size: .1%;
    text-indent: -9999px;
    background-repeat: no-repeat;
    background-position: 50%;
    background-color: #FFF;
    background-size: contain;
    width: 50px;
    height: 50px;
    border-radius: 3px;
    margin: 0;
}

label.upload-button.empty {
    background-color: rgb(229, 231, 235);
}

label.upload-button>div {
    width: 100%;
    height: 100%;
    border-radius: 3px;
    opacity: 0;
    background-repeat: no-repeat;
    background-position: 50%;
    background-color: #fff;
    background-image: url(/img/plus.svg);
    background-size: 40%;
    transition: opacity .2s ease-in-out;
}

label.upload-button:hover {
    border-style: solid;
}

label.upload-button:hover>div {
    opacity: .7;
}
</style>
